/**
 * "1,4 MB" — o tamanho de um arquivo, do jeito que se lê.
 *
 * <p>Estava copiado em <b>quatro</b> lugares: o anexo da tarefa, o anexo do comentário, o
 * acervo de documentos e a fila de transcrições. As quatro cópias faziam a mesma coisa, e
 * duas delas já divergiam em detalhe — {@code bytes / 1024 / 1024} contra
 * {@code bytes / (1024 * 1024)}. Dá no mesmo hoje; é o tipo de diferença que sobrevive
 * até alguém corrigir um arredondamento em três lugares e esquecer o quarto.
 *
 * <p>Vírgula, e não ponto: é português. O KB é arredondado e o MB tem uma casa, porque o
 * que se responde aqui é "vale a pena esperar o download?" — e para essa pergunta
 * "1,4 MB" e "1,43 MB" são a mesma resposta.
 */
export function tamanhoLegivel(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}
